'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeToggle = exports.PlayButton = exports.Countdown = exports.Label = exports.FragmentNumber = exports.PageNumber = exports.ControlB = exports.ControlA = exports.LayoutToggle = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _icon = require('@dekk/icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @private
 */
var Controls = _styledComponents2.default.div.withConfig({
  displayName: 'controls__Controls'
})(['position:relative;height:100%;width:100%;box-sizing:border-box;grid-area:Controls;display:grid;grid-template-rows:2rem 2rem auto;grid-template-columns:10rem 1fr repeat(3,2rem);grid-gap:0.25rem;grid-template-areas:\'PageNumber ControlB PlayButton ThemeToggle LayoutToggle \' \'FragmentNumber . . . .\' \'ControlA ControlA ControlA ControlA ControlA\';font-size:1rem;font-family:-apple-system,BlinkMacSystemFont,\'Segoe UI\',Roboto,Oxygen,Ubuntu,Cantarell,\'Open Sans\',\'Helvetica Neue\',sans-serif;']);
exports.default = Controls;

/**
 * @private
 */

var toggleStyle = (0, _styledComponents.css)(['background:', ';color:', ';box-shadow:0 0 0 1px ', ' inset;border:0;border-radius:3px;height:2rem;width:2rem;padding:0.5rem;font-size:1rem;cursor:pointer;&:hover{background:', ';}&:active{background:', ';}&:focus{outline:0;background:highlight;}svg{height:1em;width:1em;}'], function (_ref) {
  var theme = _ref.theme;
  return theme === 'dark' ? '#222' : '#ddd';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme === 'dark' ? '#ddd' : '#222';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme === 'dark' ? '#333' : '#ccc';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme === 'dark' ? '#333' : '#ccc';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme === 'dark' ? '#444' : '#bbb';
});

/**
 * @private
 */
var StyledLayoutToggle = _styledComponents2.default.button.withConfig({
  displayName: 'controls__StyledLayoutToggle'
})(['grid-area:LayoutToggle;', ';'], toggleStyle);

/**
 * @private
 */
var LayoutToggle = exports.LayoutToggle = function LayoutToggle(props) {
  return _react2.default.createElement(
    StyledLayoutToggle,
    props,
    _react2.default.createElement(_icon2.default, { icon: _icon.icons.layout })
  );
};

/**
 * @private
 */
var StyledThemeToggle = _styledComponents2.default.button.withConfig({
  displayName: 'controls__StyledThemeToggle'
})(['grid-area:ThemeToggle;', ';'], toggleStyle);

/**
 * @private
 */
var StyledPlayButton = _styledComponents2.default.button.withConfig({
  displayName: 'controls__StyledPlayButton'
})(['grid-area:PlayButton;', ';'], toggleStyle);

/**
 * @private
 */
var ControlA = exports.ControlA = _styledComponents2.default.div.withConfig({
  displayName: 'controls__ControlA'
})(['grid-area:ControlA;position:relative;height:100%;width:100%;padding:0.75rem 1rem 1rem;box-sizing:border-box;']);

/**
 * @private
 */
var ControlB = exports.ControlB = _styledComponents2.default.div.withConfig({
  displayName: 'controls__ControlB'
})(['grid-area:ControlB;position:relative;height:100%;width:100%;box-sizing:border-box;padding:0 0.75rem;display:flex;align-items:center;align-content:center;justify-content:flex-end;']);

/**
 * @private
 */
var PageNumber = exports.PageNumber = _styledComponents2.default.div.withConfig({
  displayName: 'controls__PageNumber'
})(['position:relative;height:100%;width:100%;display:flex;align-items:center;align-content:center;grid-area:PageNumber;box-shadow:0 -1px 0 0 ', ' inset;'], function (_ref6) {
  var theme = _ref6.theme;
  return theme === 'dark' ? '#222' : '#ddd';
});

/**
 * @private
 */
var FragmentNumber = exports.FragmentNumber = _styledComponents2.default.div.withConfig({
  displayName: 'controls__FragmentNumber'
})(['position:relative;height:100%;width:100%;display:flex;align-items:center;align-content:center;grid-area:FragmentNumber;box-shadow:0 -1px 0 0 ', ' inset;'], function (_ref7) {
  var theme = _ref7.theme;
  return theme === 'dark' ? '#222' : '#ddd';
});

/**
 * @private
 */
var Label = exports.Label = _styledComponents2.default.span.withConfig({
  displayName: 'controls__Label'
})(['display:inline-block;text-align:right;padding-right:0.5rem;width:6rem;min-width:max-content;']);

/**
 * @private
 */
var Countdown = exports.Countdown = _styledComponents2.default.div.withConfig({
  displayName: 'controls__Countdown'
})(['font-size:2rem;[data-warning]{color:#a00;}']);

/**
 * @private
 */
var PlayButton = exports.PlayButton = function PlayButton(props) {
  var icon = props.isPlaying ? _icon.icons.timerOff : _icon.icons.timerOn;
  return _react2.default.createElement(
    StyledPlayButton,
    props,
    _react2.default.createElement(_icon2.default, { icon: icon })
  );
};

/**
 * @private
 */
var ThemeToggle = exports.ThemeToggle = function ThemeToggle(props) {
  var icon = props.isDark ? _icon.icons.themeLight : _icon.icons.themeDark;
  return _react2.default.createElement(
    StyledThemeToggle,
    props,
    _react2.default.createElement(_icon2.default, { icon: icon })
  );
};

/**
 * @private
 */
PlayButton.propTypes = {
  isPlaying: _propTypes2.default.bool

  /**
   * @private
   */
};PlayButton.defaultProps = {
  isPlaying: false

  /**
   * @private
   */
};ThemeToggle.propTypes = {
  isDark: _propTypes2.default.bool

  /**
   * @private
   */
};ThemeToggle.defaultProps = {
  isDark: false
};
//# sourceMappingURL=controls.js.map